import React from 'react'

import { Typography, Paper, Button } from '@mui/material'

import api from '../services/methods/plano'
import { useUser } from '../services/StateContext'
//import { useNavigate } from 'react-router-dom'
import { getItems } from '../services/utils'
import Sections from '../Components/Sections'
import Loading from '../Components/Loading'
//import WithPaginate from '../Components/WithPagination'
import { toast, ToastContainer } from 'react-toastify'

const input = { 
    name: 'idPlano', 
    label: 'descricaoPlano'
}

const Plano = () => {
    const [ data, setData ] = React.useState([])
    const { user, setUser } = useUser()

    //const navigate = useNavigate()

    const getPlanos = React.useCallback( async () => {
        
        try {
            
            setUser( prevState => ({...prevState, progress: 20, items: [], loading: true } ))

            const response = await api.getPlanos(user)
            
            if (response.data.status === -1) {
                throw response.data
            }

            const items = getItems(response.data.dados)

            setData(items)
       
        } catch (error) {
            toast.error('Ocorreu um erro ao listar os planos')    
        } finally{
            setUser( prevState => ({...prevState, loading: false}))
        }
        // eslint-disable-next-line
    }, [setUser, setData])

    
    const selectItem = item => {
        
        setUser( prevState => (
            {
                ...prevState, 
                [input.name]: item[input.name],
                [input.label]: item[input.label]
            })
        )
    }

    const getPropsButton = ({isChildren, onClick}) => {
        const props = {
            component: Paper, 
            key: 'voltar',
            sx: {
                textAlign: 'center',
                height: 80,
                width: '100%',
                //lineHeight: '80px',
                whiteSpace: 'break-spaces',
                cursor: 'pointer',
                overflow: 'hidden',
                color: '#000',
                
            },
        }

        const particular = {
            
            name: 'redirect',
            elevation: 4,
            id: 'redirect',
            onClick: _ => { 
                setUser( prevState => ({...prevState, idPlano: process.env.REACT_APP_ID_PLANO}))
            },
            value: 'particular',
            children: 'Particular'
        } 

        const voltar = {
            
            name: 'redirect',
            elevation: 4,
            id: 'redirect',
            onClick: _ => onClick('voltar'),
            value: 'voltar',
            children: 'Voltar'
        } 

        const buttonProps = !isChildren ? { ...props, ...particular } : { ...props, ...voltar} 
        return <Button {...buttonProps} />
    }

    // if (!(state.idConvenio && !state.idPlano)) {
    //     return null
    // }

    React.useEffect( () => {
        getPlanos()
    }, [getPlanos])

    console.log(user, 'USER')
    return <>
        <ToastContainer />
        <Typography variant="h3" component="h1">Qual o plano do seu convênio?</Typography>
        <Sections 
            items={data} 
            totalByPerPage={7} 
            selectItem={selectItem} 
            input={input}
            ButtonAction={getPropsButton}
        />
        {user.loading && <Loading />}
    </>
     
}

export default Plano










// React.useEffect(() => {
//     const getPlano = async () => { 
//         const body = {
//             aliasEmpresa: 'ACOR',
//             hash: 'ad655c0a14276899ce6b401843115d18', 
//             funcao: 'getPlano',
//             idConvenio: state.idConvenio, 
            
//         }
//         const { data } = await API.post('/plano.php', body)
//         if (data.status === 1) {
            
//             setState( prevState => { 

//                 const planos = prevState.getItems(data.dados)
            
//                 return {
//                     ...prevState, 
//                     planos, 
//                     items: prevState.getPaginate(planos, 16, 0), //: prevState.getConvenioOptions(data.dados)
//                 }
//             })
//         }
        
//     }

//     getPlano()

// }, [])